var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Model from './Model';
import { observable } from 'mobx';
/**
 *
 */
var ServiceAssetSchemaModel = /** @class */ (function (_super) {
    __extends(ServiceAssetSchemaModel, _super);
    /**
     *
     * @param data
     */
    function ServiceAssetSchemaModel(data) {
        return _super.call(this, data) || this;
    }
    /**
     *
     * @param data
     */
    ServiceAssetSchemaModel.prototype.update = function (data) {
        var _this = this;
        if (!data)
            return;
        var keys = Object.keys(data);
        keys.map(function (key) {
            switch (key) {
                case 'creationDateTimeUtc':
                case 'lastModifiedDateTimeUtc':
                case 'lastTriggeredDateTimeUtc':
                case 'lastCloseDateTimeUtc':
                case 'timestamp':
                    _this[key] = data[key] ? new Date(data[key]) : null;
                    break;
                default:
                    _this[key] = data[key];
            }
        });
    };
    __decorate([
        observable
    ], ServiceAssetSchemaModel.prototype, "assetId", void 0);
    __decorate([
        observable
    ], ServiceAssetSchemaModel.prototype, "schemaId", void 0);
    __decorate([
        observable
    ], ServiceAssetSchemaModel.prototype, "createdByUserId", void 0);
    __decorate([
        observable
    ], ServiceAssetSchemaModel.prototype, "creationDateTimeUtc", void 0);
    __decorate([
        observable
    ], ServiceAssetSchemaModel.prototype, "lastModifiedDateTimeUtc", void 0);
    __decorate([
        observable
    ], ServiceAssetSchemaModel.prototype, "lastTriggeredDateTimeUtc", void 0);
    __decorate([
        observable
    ], ServiceAssetSchemaModel.prototype, "lastCloseDateTimeUtc", void 0);
    __decorate([
        observable
    ], ServiceAssetSchemaModel.prototype, "assetValueOnLastClose", void 0);
    __decorate([
        observable
    ], ServiceAssetSchemaModel.prototype, "timestamp", void 0);
    __decorate([
        observable
    ], ServiceAssetSchemaModel.prototype, "lastCreatedServiceEntryId", void 0);
    __decorate([
        observable
    ], ServiceAssetSchemaModel.prototype, "lastTriggerStatusInfo", void 0);
    __decorate([
        observable
    ], ServiceAssetSchemaModel.prototype, "nextTriggerAssetValue", void 0);
    __decorate([
        observable
    ], ServiceAssetSchemaModel.prototype, "nextTriggerReminderBeforeIntervalValue", void 0);
    __decorate([
        observable
    ], ServiceAssetSchemaModel.prototype, "triggerStatus", void 0);
    return ServiceAssetSchemaModel;
}(Model));
export default ServiceAssetSchemaModel;
